import { createRoot, type Root } from 'react-dom/client';
import { createPortal } from 'react-dom';
import Loading from '../Loading';

let container: HTMLDivElement | null = null;
let root: Root | null = null;

const showLoading = (opacity = false) => {
  if (container) {
    return;
  }
  try {
    container = document.createElement('div');
    document.body.appendChild(container);
    root = createRoot(container);
    root.render(createPortal(<Loading opacity={opacity} />, document.body));
  } catch (error) {
    console.error('Loading create error:', error);
    root?.unmount();
    container?.remove();
    root = null;
    container = null;
  }
};

const hideLoading = () => {
  if (!container) {
    return;
  }
  root?.unmount();
  container.remove();
  root = null;
  container = null;
};

export { showLoading, hideLoading };
